import React from "react";
import Callout from "components/Callout";
import Button from "components/Form/fields/Button";
import classnames from "classnames";
import { STATE_KEYS } from "utils/constants/state";
import { PRODUCT_ORDER_INTENT } from "utils/constants/pricing";

const EmptyPricingTableList = ({
  hasProductsOffTable,
  hasProducts,
  setFieldValue
}) => {
  const copy = hasProductsOffTable
    ? "Drag products here to add to the pricing table."
    : "Create products to add to the pricing table.";

  return (
    <Callout
      copy={copy}
      customClasses={{
        container:
          "flex items-center bt bb b--black-05 ph3 pv4 w-100 justify-between h-100 bh--inset",
        copy: classnames("pa3 f7 ba br2 w-100 lh-copy", {
          "hairline-1": !hasProductsOffTable,
          "hairline-1-dashed-primary": hasProductsOffTable
        })
      }}
    >
      {!hasProducts && (
        <Button
          theme="slim"
          onClick={() =>
            setFieldValue(
              STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT,
              PRODUCT_ORDER_INTENT.PRODUCT_ADD
            )
          }
          copy="Create product"
        />
      )}
    </Callout>
  );
};

export default EmptyPricingTableList;
